import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPanelAutoGen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.25 20.5C14.25 20.9142 13.9142 21.25 13.5 21.25H6.5C4.42893 21.25 2.75 19.5711 2.75 17.5V6.5C2.75 4.42893 4.42893 2.75 6.5 2.75H17.5C19.5711 2.75 21.25 4.42893 21.25 6.5V13.5C21.25 13.9142 20.9142 14.25 20.5 14.25C20.0858 14.25 19.75 13.9142 19.75 13.5V6.5C19.75 5.25736 18.7426 4.25 17.5 4.25H6.5C5.25736 4.25 4.25 5.25736 4.25 6.5V17.5C4.25 18.7426 5.25736 19.75 6.5 19.75H13.5C13.9142 19.75 14.25 20.0858 14.25 20.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 8C7.75 7.58579 8.08579 7.25 8.5 7.25H15.5C15.9142 7.25 16.25 7.58579 16.25 8C16.25 8.41421 15.9142 8.75 15.5 8.75H8.5C8.08579 8.75 7.75 8.41421 7.75 8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.3113 13.0817C18.0628 12.2864 16.9372 12.2864 16.6887 13.0817L16.1522 14.7984C15.922 15.5351 15.3302 16.1024 14.5844 16.3013L13.0978 16.6977C12.3075 16.9085 12.2417 18.0045 13.0011 18.3082L14.8404 19.0439C15.4394 19.2835 15.9067 19.7687 16.1237 20.3763L16.6995 21.9886C16.9682 22.7407 18.0319 22.7407 18.3005 21.9886L18.8763 20.3763C19.0933 19.7687 19.5606 19.2835 20.1596 19.0439L21.9989 18.3082C22.7583 18.0045 22.6925 16.9085 21.9022 16.6977L20.4156 16.3013C19.6698 16.1024 19.078 15.5351 18.8478 14.7984L18.3113 13.0817ZM15.3442 17.6299C16.331 17.2526 17.1159 16.4744 17.5 15.4857C17.8841 16.4744 18.669 17.2526 19.6558 17.6299L19.6025 17.6512C18.6364 18.0377 17.8758 18.8074 17.5 19.7744C17.1242 18.8074 16.3636 18.0377 15.3975 17.6512L15.3442 17.6299Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconPanelAutoGen as ReactComponent };
